"use strict";

exports.__esModule = true;
var _DeviceStatusController = require("./DeviceStatusController");
Object.keys(_DeviceStatusController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceStatusController[key]) return;
  exports[key] = _DeviceStatusController[key];
});